import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/CustomerSupport/QueryDetails.css';
import user from '../../../Assets/CustomerSupport/Assets-WebApp/user.svg';
import SuccessModal from '../../Shared/SuccessModal';
import Button from '../../Shared/Button';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import star from '../../../Assets/CustomerSupport/Assets-WebApp/star.svg';
import starfilled from '../../../Assets/CustomerSupport/Assets-WebApp/star-filled.svg';
import RatingModal from '../../Shared/RatingModal';
import AcceptTermsConditionsModal from '../../Shared/AcceptTermsConditionsModal';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';

class QueryDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            Category: 'Quotes',
            ReferenceNo: '1234567',
            InitiatedOn: '29-Jan-2021',
            Status: 'PENDING',
            Message: 'Hi team, I want to export 120 containers from South Africa to Australia. Please let me know how can I request quotation.',
            MessageTime: '29-Jan-2021 17:18',
            replyMessage: 'You can request quotation from Respondents by filling your requirements under “Request Quotation” icon available on Home screen.',
            replyMessageTime: '29-Jan-2021 19:31',
            RatingStar: '',
            RatingComment: 'Thank you for quick response and helping me for resolving the query.',
            RatingTime: '29-Jan-2021 20:15',
            ReplyCardShow: true,
            RatingCardShow: false,
            hasOpen: false,
            hasOpenSuccess: false,
            textComment: '',
            textLimit: 0,
            errormodel: {},
            errorStarReason: '',
            errorReason: '',
            hasOpentermsCondition: false,
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.updateRating = this.updateRating.bind(this);
    }

    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    updateRating(index) {
        this.setState({ RatingStar: index + 1 });
        this.setState({ errorStarReason: '' });
    }

    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ ProxyDocumentdropdown: false });
        }
    };

    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
        this.props.history.push('/QueryDetails', {});
        this.setState({ RatingCardShow: true });
    };

    onSumbitRating = () => {
        if (this.handleValidationModel()) {
            document.documentElement.scrollTop = 0;
            this.setState({ hasOpen: false });
            this.setState({ hasOpenSuccess: true });
        }
    };

    onSubmitQuery = () => {
        document.documentElement.scrollTop = 0;
        this.setState({ hasOpen: true });
    }

    onClickCross = () => {
        this.setState({ hasOpen: false });
        window.location.reload();
    }

    handleTextMessage = (e) => {
        if (e.target.value?.length <= 100) {
            this.setState({ textLimit: e.target.value?.length });
            this.setState({ textComment: e.target.value });
            this.setState({
                errorReason: ''
            });
            document.getElementsByName('textComment')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }

    handleValidationModel() {
        let errorReason = '';
        let errorStarReason = '';
        let formIsValid = true;
        if (this.state.hasOpen == true) {
            if (!this.state.textComment) {
                formIsValid = false;
                errorReason = Message.validation.required;
                document.getElementsByName('textComment')[0].style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementsByName('textComment')[0].style.borderColor = ColorCode.colorCode.black;
            }
            if (!this.state.RatingStar) {
                formIsValid = false;
                errorStarReason = Message.validation.rating;
            }
        }
        this.setState({ errorReason: errorReason });
        this.setState({ errorStarReason: errorStarReason })
        return formIsValid;
    }

    render() {
        return (
            <div class="contactcaacsoutercolor">
                <MetaDecorator title={TitleDescription.queryDetailsPageTitle} description={TitleDescription.queryDetailsPageDescription} />
                <Header  tilesFetched = {()=>{}}/>
                <div class="contactcaacsnofullprepro">
                    <div id="contactcaacsnobox1prepro">
                        <nav class="contactcaacnononavbar">
                            <div className="contactarcaacnonavbarname">
                                <small id="contactnonavc">Query Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="allQueriesmaincarddiv">
                            <div class="querydetailsdivup">
                                <div class="querydetailsdivuprow">
                                    <small class="querydetailsdivupsm1b">Category : </small>
                                    <small class="querydetailsdivupsm2b">{this.state.Category}</small>
                                </div>
                                <div class="querydetailsdivuprow">
                                    <small class="querydetailsdivupsm1">Reference No : </small>
                                    <small class="querydetailsdivupsm2">{this.state.ReferenceNo}</small>
                                </div>
                                <div class="querydetailsdivuprow">
                                    <small class="querydetailsdivupsm1time">Initiated on: </small>
                                    <small class="querydetailsdivupsm2time">{this.state.InitiatedOn}</small>
                                </div>
                                <div class="querydetailsdivuprow">
                                    <small class="querydetailsdivupsm1s">Status : </small>
                                    {(this.state.Status === "PENDING") ?
                                        <small class="querydetailsdivupsmpen">{this.state.Status}</small>
                                        :
                                        <small class="querydetailsdivupsm2">{this.state.Status}</small>
                                    }
                                </div>
                            </div>
                            <div class="querydetailsdivmidout">
                                <div class="querydetailsdivmid">
                                    <div class="querydetailsdivmidin">
                                        <small class="querydetailsdivmidsm">{this.state.Message}</small>
                                    </div>
                                </div>
                                <small class="querydetailstimeright">{this.state.MessageTime}</small>
                            </div>
                            {(this.state.ReplyCardShow) &&
                                <div>
                                    <div class="querydetailsdivmidtwo">
                                        <div class="querydetailsavtardiv">
                                            <img src={user} class="" alt="" loading="lazy" />
                                        </div>
                                        <div class="querydetailsmessagediv">
                                            <div class="querydetailsmesdiv">
                                                <div class="querydetailsmesdivin">
                                                    <small class="querydetailsmesdivsm">{this.state.replyMessage}</small>
                                                </div>
                                            </div>
                                            <small class="querydetailstimeleft">{this.state.replyMessageTime}</small>
                                            {(this.state.RatingCardShow) &&
                                                <div class="querydetailsratdiv">
                                                    <div class="querydetailsratingcard">
                                                        <div class="querydetailsratingcardin">
                                                            <small class="querydetailsratingsm1">
                                                                You rated this query : {this.state.RatingStar} Stars
                                                </small>
                                                            <small class="querydetailsratingsm2">
                                                                Your Comment :
                                                </small>
                                                            <small class="querydetailsratingsm3">
                                                                {this.state.textComment}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <small class="querydetailstimeleft">{this.state.RatingTime}</small>
                                                </div>}
                                        </div>
                                    </div>
                                    {(!this.state.RatingCardShow) &&
                                        <div class="querydetailsbuttdiv">
                                            <Button class="querydetailsbutt" onClick={this.onSubmitQuery}>
                                                <small class="querydetailsbuttsm">OK</small>
                                            </Button>
                                        </div>}
                                </div>}
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01ahzpreexp">
                    <Footer />
                </div>
                <div class="caanotifooter02ahzpreexp">
                    <Footer2 />
                </div>
                <RatingModal hasOpen={this.state.hasOpen} onCloseModal={this.onSumbitRating} onCrossModal={this.onClickCross}>
                    <div class="ratingDivOut">
                        <div class="ratingHeadDiv">
                            <small class="ratingHeadsm">How would you rate our service?</small>
                        </div>
                        <div class="ratingImgDiv">
                            <div class="ratingImgDivin">
                                {[1, 1, 1, 1, 1].map((item, index) => (
                                    <div class="ratingmodalimgposition"
                                        onClick={() => this.updateRating(index)}
                                        key={index}
                                    >
                                        <img src={index < this.state.RatingStar ? starfilled : star} class="ratingImgStar" alt="" loading="lazy" />
                                    </div>
                                ))}
                            </div>
                            <div className="ratingstarunfillerror">{this.state.errorStarReason}</div>
                        </div>
                        <div class="ratingInputHeadDiv">
                            <small class="ratingInputHead">Please leave a comment below</small>
                            <textarea name="textComment" class="ratinginputlbor2raise" type="text" value={this.state.textComment}
                                id="textMessage"
                                onChange={this.handleTextMessage}
                            ></textarea>
                            <div className="appointmentdetailserror11">{this.state.errorReason}</div>
                            <small class="ratinginpsmallraise">{this.state.textLimit}/100</small>
                        </div>
                    </div>
                </RatingModal>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">We have received your response. </small>
                            <small class="successRatingdivsm"> Thanks for the feedback.</small>
                        </div>
                    </div>
                </SuccessModal>
                <AcceptTermsConditionsModal hasOpen={this.state.hasOpentermsCondition} onCloseModal={this.onCloseModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="AccepttermscondiDivout">
                            <small class="AccepttermscondiDivsm">Terms & Conditions Updated</small>
                            <small class="AccepttermscondiDivsmb"> Last Updated 19-Feb-2021</small>
                            <div class="AccepttermscondiDivin">
                                <small class="AccepttermscondiDivinsm">Please read and accept the new</small>
                                <small class="AccepttermscondiDivinsmb">
                                    <small class="AccepttermscondiDivinsmtc">Terms & Conditions </small>
                                to proceed.
                                </small>
                            </div>
                        </div>
                    </div>
                </AcceptTermsConditionsModal>
            </div>
        );
    }
}

export default QueryDetails;